import api from '../api';

const axiosConfig = {
  headers: {
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache'
  },
};
const BASE_URL = process.env.REACT_APP_API_URL;

const CallLogService = {
  createLog: async (data) => {
    try{
      return await api.post(`${BASE_URL}/call-logs`, data, axiosConfig);
    }catch(error){
      console.log("Error in creating call-logs.", [error]);
      throw error;
    }
  },
  
  updateLog: async (id, data) => {
    try{
      return await api.put(`${BASE_URL}/call-logs/${id}`, data, axiosConfig);
    }catch(error){
      console.log("Error in updating call-logs.", [error]);
      throw error;
    }
  },
  
  deleteLog: async (id) => {
    try{
      return await api.delete(`${BASE_URL}/call-logs/${id}`, axiosConfig);
    }catch(error){
      console.log("Error in deleting call-logs.", [error]);
      throw new Error (error.response?.data?.message || error.message) || error;
    }
  },
  
  getLog: async (id) => {
    try{
      return await api.get(`${BASE_URL}/call-logs/${id}`, axiosConfig);
    }catch(error){
      console.log("Error in getting call-logs data.", [error]);
      throw new Error (error.response?.data?.message || error.message) || error;
    }
  },

  getAllLogs: async () => {
    try{
      return await api.get(`${BASE_URL}/call-logs`, axiosConfig); 
    }catch(error){
      console.log("Error in getting call-logss data.", [error]);
      throw new Error (error.response?.data?.message || error.message) || error;
    }
  },

  getLogByType: async (type, id) => {
    try {
      return await api.get(`${BASE_URL}/call-logs/${type}/${id}`, axiosConfig);  
    } catch (error) {
      console.log("Error in getting call-logs data.", [error]);
      throw new Error (error.response?.data?.message || error.message) || error;
    }
  }
  
};

export default CallLogService;
